import axios from "axios";

export const httpClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/page`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const sendhttpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
